import {createStore, createEvent, sample} from '@effector/effector'
import {runtimeID, onRuntimeEvent} from './runtimeID'

const runtimeConsoleEvent = createEvent<{
  method: keyof typeof console
  args: any[]
}>()
export const consoleApi = {}
for (const key in console) {
  consoleApi[key] = (...args) => {
    //@ts-ignore
    runtimeConsoleEvent({method: key, args})
  }
}

const runtimeConsole = sample({
  source: runtimeID,
  clock: runtimeConsoleEvent,
  fn: (runtimeID, {method, args}) => ({
    runtimeID,
    method,
    args,
    consoleCallID: ++nextConsoleCallID
  }),
  greedy: true
})

export const log = createStore<
  Array<{
    method: keyof typeof console
    args: any[]
    runtimeID: string
    consoleCallID: number
  }>
>([]).on(runtimeID, (list, runtimeID) =>
  list.filter(item => item.runtimeID === runtimeID)
)

onRuntimeEvent({
  target: log,
  clock: runtimeConsole,
  filter: (item, runtimeID) => item.runtimeID === runtimeID,
  fn: (list, items) => [...list, ...items].slice(-10)
})

let nextConsoleCallID = 0
